import {Card, Box, Typography} from '@material-ui/core';
import {useTranslate} from "react-admin";

import {dashboard} from '../../styles/dashboard';
import CircularProgress from "@material-ui/core/CircularProgress";
import {useEffect, useState} from "react";
import axiosForApi from "../../config/axios-for-api";
import StatHeader from "./StatHeader";

const Loading = () => {
    return (
        <Box display={'flex'} justifyContent={'center'}>
            <CircularProgress size={28.8}/>
        </Box>
    );
}

const StatResult = ({classes, totalThisYear, totalThisMonth}: any) => {
    return (
        <Typography className={classes.statsTotal} color="textSecondary">
            {totalThisMonth}/{totalThisYear}
        </Typography>
    );
}

const RegisteredCustomers = ({countries, forCatalogOffers = false}: { countries: string[] | null, forCatalogOffers?:boolean }) => {
    const classes = dashboard();
    const translate = useTranslate();

    const [statsData, setStatsData] = useState({
        total_this_year_fmt: '',
        total_this_month_fmt: ''
    });
    const [shouldLoadStatsData, setShouldLoadStatsData] = useState(false);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        let cancel = false;

        const loadStatsData = async () => {
            const {data} = await axiosForApi.get(`api/admin/${forCatalogOffers?'catalog-offer-stats':'stats'}/total-registered-${forCatalogOffers?'catalog-customers':'customers'}-now`, {
                params: {
                    countries
                }
            });
            if (!cancel) {
                setLoading(false);
                setStatsData(data ?? null);
                setShouldLoadStatsData(false);
            }
        }

        shouldLoadStatsData && loadStatsData();

        return () => {
            cancel = true;
        }
    }, [shouldLoadStatsData, countries, forCatalogOffers]);

    useEffect(() => {
        setLoading(true);
        setShouldLoadStatsData(true);
    }, [countries]);

    return (
        <Card className={classes.card}>
            <Box p={2}>
                <StatHeader
                    // title='Neukunden Monat / Total'
                    title={translate('resources.admin/dashboard.headers.total-registered-customers-now')}
                    help={`resources.admin/dashboard.${forCatalogOffers?'catalog_offers_help':'help'}.total-registered-${forCatalogOffers?'catalog-customers':'customers'}-now`}
                />
                {loading ? <Loading/> : <StatResult
                    classes={classes}
                    totalThisYear={statsData.total_this_year_fmt}
                    totalThisMonth={statsData.total_this_month_fmt}
                />}
            </Box>
        </Card>
    );
}

export default RegisteredCustomers;
